import { ApiCaller } from 'helpers';
import { mapAemData } from 'modules/brochureware/helpers';
import { getImpressumEndPoint } from 'modules/brochureware/url-helper';

export const fetchImpressum: any = async (languageCode) => {
  const data = await ApiCaller.get(getImpressumEndPoint(languageCode));
  return mapAemData(data);
};
